var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHeartBubble = function SvgHeartBubble(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 42 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "evenodd",
    d: "M34 0a8 8 0 0 1 8 8v18a8 8 0 0 1-8 8h-6.51L21 39.958 14.181 34H8a8 8 0 0 1-8-8V8a8 8 0 0 1 8-8h26zM12.133 10.32c-2.31 2.353-2.31 6.168 0 8.52l8.408 8.564a.5.5 0 0 0 .719 0l8.409-8.564c2.31-2.352 2.31-6.167 0-8.52a5.84 5.84 0 0 0-8.364 0c-.32.328-.404.47-.404.47s-.255-.316-.405-.47a5.838 5.838 0 0 0-8.363 0z"
  })));
};
export default SvgHeartBubble;